import { useContext, useEffect } from 'react';
import { SubItemFormFilling } from '../../../Filling/Types';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Stack, Typography } from '@mui/material';
import CheckIcon from '../../CheckIcon';
import React, { useRef } from "react";
import Signature from '@uiw/react-signature/canvas';
import SaveIcon from '@mui/icons-material/Save';
import AdditionalInfo from '../../Structure/AdditionalInfo';
import { NewWebFormContext } from '../../../../context/NewWebFormContext';

type props = {
  subitem: SubItemFormFilling,
  assinatura: string | null,
  setAssinatura: Function,
};

export default function Assinatura({
  assinatura,
  setAssinatura,
  subitem,
}: props) {
  const refAssinatura = useRef(null) as React.MutableRefObject<any>;
  const { ForceUpdate } = useContext(NewWebFormContext);

  const textFieldTitle: string = (() => {
    let title = '';
    if (CheckIcon(subitem, assinatura) === 'naoOk') {
      title += '* ';
    }
    title += `${subitem.id + 1} - ${subitem.nome}`;
    return title;
  })();

  const style = {
    width: 400,
    bgcolor: 'inherit',
    border: '2px solid #D9D9DF',
    boxShadow: 24,
  };

  function handleSave() {
    setAssinatura(refAssinatura.current.canvas.toDataURL());
  }

  function handleClear() {
    refAssinatura.current.clear();
    setAssinatura(null);
    delete subitem.assinatura;
  }

  useEffect(() => {
    if (subitem.assinatura) {
      setAssinatura(subitem.assinatura);
    }
  }, []);

  useEffect(() => {
    if (assinatura) {
      (subitem.assinatura as string | null) = assinatura;
    } if (CheckIcon(subitem, assinatura) === 'ok') {
      subitem.checked = true;
    } else {
      delete subitem.checked;
    }
    ForceUpdate();
  }, [assinatura]);

  return (
    <>
      <Typography
        variant='h6'
        style={{
          wordBreak: 'break-all',
          marginBottom: '5px',
          width: '100%',
          textAlign: 'left'
        }}>
        {textFieldTitle}
      </Typography>
      <Stack
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          maxHeight: '100%',
          height: '100%'
        }}
      >
        <Box sx={style} >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={0}
          >
            <>
              <Signature
                className={`${subitem.itemid}|${subitem.id}`}
                style={{ display: !assinatura ? '' : 'none', backgroundColor: 'inherit' }}
                width={350}
                height={200}
                ref={refAssinatura}
              />
              <div ref={refAssinatura}>
                <img
                  alt=''
                  style={{ display: assinatura ? '' : 'none' }}
                  width={350}
                  height={200}
                  src={assinatura as string}
                />
              </div>
            </>
            <Stack
              style={{ width: 'fit-content', height: '100%' }}
              direction="column"
              justifyContent="flex-end"
              alignItems="flex-end"
              spacing={4}
            >
              {!assinatura ? <SaveIcon
                fontSize='large'
                sx={{ fontSize: '45px', cursor: 'pointer', ':hover': { color: 'black' } }}
                color='action'
                onClick={() => handleSave()}
              /> :
                <DeleteIcon
                  fontSize='large'
                  sx={{ fontSize: '45px', cursor: 'pointer', ':hover': { color: '#ab003c' } }}
                  color='error'
                  onClick={() => handleClear()}
                />}
            </Stack>
          </Stack>
        </Box>
      </Stack >
      {(subitem.foto || subitem.comentario) && assinatura && <AdditionalInfo subItem={subitem} />}
    </>
  );
}